export default {
    name: "SafeHtmlRenderer",
    functional: true,
    props: {
        content: {
            type: String,
            required: true,
        },
        tag: {
            type: String,
            default: "div",
        },
    },
    render(h, context) {
        const existingOn = context.data?.on || {}

        const handleClick = event => {
            const anchor = event?.target?.closest?.("a")
            if (anchor) {
                // Keep link behavior but avoid parent controls (e.g. checkbox labels) consuming the click.
                event.stopPropagation()
            }
            existingOn.click?.(event)
        }

        return h(context.props.tag, {
            ...context.data,
            on: {
                ...existingOn,
                click: handleClick,
            },
            domProps: {
                ...(context.data?.domProps || {}),
                innerHTML: context.props.content,
            },
        })
    },
}
